export default "__VITE_ASSET__BNR6HCWL__"